// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

// Your web app's Firebase configuration
// ERSTATT DETTE MED DIN EGEN firebaseConfig FRA FIREBASE-KONSOLLET!
const firebaseConfig = {
  apiKey: "AIzaSyDvdew2Vb7GScc3HYArnrpYNmiS_9aJa64",
  authDomain: "bikesuit-74ab5.firebaseapp.com",
  projectId: "bikesuit-74ab5",
  storageBucket: "bikesuit-74ab5.firebasestorage.app",
  messagingSenderId: "732743304684",
  appId: "1:732743304684:web:47ffb8aed2e35605bb6cc9",
  measurementId: "G-XBDH7HVQ5J"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Cloud Firestore and get a reference to the service
const db = getFirestore(app);

export { db }; // Eksporter db-instansen slik at du kan bruke den i andre filer